if (!customElements.get('quantity-input')) {

  class QuantityInput extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input');

      // this.querySelectorAll('button').forEach((button) =>
      //   button.addEventListener('click', this.handleButton.bind(this))
      // );

      // this.input.addEventListener('change', this.handleInputChange.bind(this));

      this.addEventListener('click' || 'change', this.delegateEvents.bind(this));

      this.debouncedUpdateQuantity = debounce((index, value) => {
        const cartItems = this.closest('cart-items');
        cartItems.updateQuantity(index, value);
      }, 500);

    }

    delegateEvents(e) {
      // console.log("DELEGATE", e.target);
      if (e.target.matches('button')) {
        this.handleButton(e);
      } else if (e.target.matches('input')) {
        this.handleInputChange(e);
      }
    }

    handleButton = (e) => {
      e.preventDefault();

      if (e.target.name === 'plus') {
        this.input.stepUp();
      } else {
        this.input.stepDown();
      }

      this.debouncedUpdateQuantity(this.dataset.index, this.input.value);
    }

    handleInputChange = (e) => {
      this.debouncedUpdateQuantity(this.dataset.index, this.input.value);
    }

    connectedCallback() {}
    disconnectedCallback() {}

  }

  customElements.define('quantity-input', QuantityInput);

}